(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    define([], function(){ return factory(root); });
  } else if (typeof module === 'object' && module.exports) {
    module.exports = factory(globalThis || (typeof self !== 'undefined' ? self : this));
  } else {
    root.SwishTennisLines = factory(root);
  }
}(typeof self !== 'undefined' ? self : this, function (GLOBAL) {
  'use strict';

  function normHex(x){ if(!x) return '#FFFFFF'; x=String(x).trim(); if(x[0] !== '#') x='#'+x; return x.toUpperCase(); }
  function hasKeys(obj) {
    if (!obj) return false;
    for (const _ in obj) return true;
    return false;
  }
  function resolveOfficial(rulesetId) {
    const cfg = GLOBAL && GLOBAL.SwishCBConfig;
    if (cfg && typeof cfg.resolveOfficialCourtGeometry === 'function') {
      try { return cfg.resolveOfficialCourtGeometry(rulesetId, { noSeries: true }); } catch (_) {}
    }
    return null;
  }

  const OFFICIAL = resolveOfficial('TENNIS');
  const OFFICIAL_RAW = (OFFICIAL && OFFICIAL.official) || {};
  const COURT = {
    LENGTH: Number(OFFICIAL && OFFICIAL.officialLengthM) || 23.7744,
    WIDTH: Number(OFFICIAL && OFFICIAL.officialWidthM) || 10.9728,
    SINGLES_WIDTH: Number(OFFICIAL_RAW.singlesWidth) || 8.2296,
    SERVICE_LINE_FROM_NET: Number(OFFICIAL_RAW.serviceLineFromNet) || 6.4008,
    CENTER_MARK_LEN: Number(OFFICIAL_RAW.centerMarkLength) || 0.1016,
    LINE: Number(OFFICIAL && OFFICIAL.lineWidthM) || 0.0508
  };
  const HALF_LENGTH = COURT.LENGTH / 2;
  const SERVICE_BOX_DEPTH = COURT.SERVICE_LINE_FROM_NET;
  const BASELINE_TO_SERVICE = HALF_LENGTH - SERVICE_BOX_DEPTH;
  const DOUBLES_MARGIN = (COURT.WIDTH - COURT.SINGLES_WIDTH) / 2;
  const SERVICE_BOX_HALF_WIDTH = COURT.SINGLES_WIDTH / 2;
  const LEFT_SERVICE_START = BASELINE_TO_SERVICE;
  const LEFT_SERVICE_END = HALF_LENGTH;
  const RIGHT_SERVICE_START = HALF_LENGTH;
  const RIGHT_SERVICE_END = COURT.LENGTH - BASELINE_TO_SERVICE;
  const RIGHT_NOMANS_START = COURT.LENGTH - BASELINE_TO_SERVICE;
  const CENTER_Y = COURT.WIDTH / 2;
  const SKIP_COLOR = '__SKIP__';

  function makePart(id, order, role, fallback, side, draw) {
    return { id, order, role, fallback, side, draw };
  }

  function fillRect(ctx, dims, color, x, y, w, h) {
    ctx.fillStyle = (GLOBAL.SwishCBHardwood && typeof GLOBAL.SwishCBHardwood.getFillStyle === 'function')
      ? GLOBAL.SwishCBHardwood.getFillStyle(ctx, color, { hardwood: dims.hardwood, pattern: dims.pattern, patternTarget: dims.patternTarget, pixelsPerMeter: dims.scaleAvg })
      : color;
    ctx.fillRect(
      x * dims.scaleX,
      y * dims.scaleY,
      w * dims.scaleX,
      h * dims.scaleY
    );
  }

  // Draw lines as filled rects (not strokes) so thickness is perfectly uniform,
  // and edge/border lines don't render "thicker" due to half-stroke clipping/AA.
  function fillLineH(ctx, dims, color, x1, x2, yM, widthM, align) {
    const wPx = dims.fixedLineWidthPx || (widthM * dims.scaleAvg);
    const xPx1 = x1 * dims.scaleX;
    const xPx2 = x2 * dims.scaleX;
    const left = Math.min(xPx1, xPx2);
    const width = Math.abs(xPx2 - xPx1);
    const yPx = yM * dims.scaleY;
    const top =
      align === 'inside-top' ? yPx :
      align === 'inside-bottom' ? (yPx - wPx) :
      (yPx - wPx / 2);
    ctx.fillStyle = color;
    ctx.fillRect(left, top, width, wPx);
  }

  function fillLineV(ctx, dims, color, xM, y1, y2, widthM, align) {
    const wPx = dims.fixedLineWidthPx || (widthM * dims.scaleAvg);
    const yPx1 = y1 * dims.scaleY;
    const yPx2 = y2 * dims.scaleY;
    const top = Math.min(yPx1, yPx2);
    const height = Math.abs(yPx2 - yPx1);
    const xPx = xM * dims.scaleX;
    const left =
      align === 'inside-left' ? xPx :
      align === 'inside-right' ? (xPx - wPx) :
      (xPx - wPx / 2);
    ctx.fillStyle = color;
    ctx.fillRect(left, top, wPx, height);
  }

  function drawCenterMarks(ctx, dims, color) {
    // A centre mark runs perpendicular to the baseline, inward into the court.
    fillLineH(ctx, dims, color, 0, COURT.CENTER_MARK_LEN, CENTER_Y, COURT.LINE, 'center');
    fillLineH(ctx, dims, color, COURT.LENGTH - COURT.CENTER_MARK_LEN, COURT.LENGTH, CENTER_Y, COURT.LINE, 'center');
  }

  const PARTS = [
    // Left half areas
    makePart('tennisLeftNoMansLand', 10, 'area', 'main', 'left', (ctx, dims, color) => {
      fillRect(ctx, dims, color, 0, DOUBLES_MARGIN, BASELINE_TO_SERVICE, COURT.SINGLES_WIDTH);
    }),
    makePart('tennisLeftLeftServiceCourt', 20, 'area', 'key', 'left', (ctx, dims, color) => {
      fillRect(ctx, dims, color, LEFT_SERVICE_START, DOUBLES_MARGIN, SERVICE_BOX_DEPTH, SERVICE_BOX_HALF_WIDTH);
    }),
    makePart('tennisLeftRightServiceCourt', 30, 'area', 'key', 'left', (ctx, dims, color) => {
      fillRect(ctx, dims, color, LEFT_SERVICE_START, DOUBLES_MARGIN + SERVICE_BOX_HALF_WIDTH, SERVICE_BOX_DEPTH, SERVICE_BOX_HALF_WIDTH);
    }),
    makePart('tennisLeftLeftDoublesAlley', 40, 'area', 'border', 'left', (ctx, dims, color) => {
      fillRect(ctx, dims, color, 0, 0, HALF_LENGTH, DOUBLES_MARGIN);
    }),
    makePart('tennisLeftRightDoublesAlley', 50, 'area', 'border', 'left', (ctx, dims, color) => {
      fillRect(ctx, dims, color, 0, COURT.WIDTH - DOUBLES_MARGIN, HALF_LENGTH, DOUBLES_MARGIN);
    }),
    // Right half areas
    makePart('tennisRightNoMansLand', 60, 'area', 'main', 'right', (ctx, dims, color) => {
      fillRect(ctx, dims, color, RIGHT_NOMANS_START, DOUBLES_MARGIN, BASELINE_TO_SERVICE, COURT.SINGLES_WIDTH);
    }),
    makePart('tennisRightLeftServiceCourt', 70, 'area', 'key', 'right', (ctx, dims, color) => {
      fillRect(ctx, dims, color, RIGHT_SERVICE_START, DOUBLES_MARGIN, SERVICE_BOX_DEPTH, SERVICE_BOX_HALF_WIDTH);
    }),
    makePart('tennisRightRightServiceCourt', 80, 'area', 'key', 'right', (ctx, dims, color) => {
      fillRect(ctx, dims, color, RIGHT_SERVICE_START, DOUBLES_MARGIN + SERVICE_BOX_HALF_WIDTH, SERVICE_BOX_DEPTH, SERVICE_BOX_HALF_WIDTH);
    }),
    makePart('tennisRightLeftDoublesAlley', 90, 'area', 'border', 'right', (ctx, dims, color) => {
      fillRect(ctx, dims, color, HALF_LENGTH, 0, HALF_LENGTH, DOUBLES_MARGIN);
    }),
    makePart('tennisRightRightDoublesAlley', 100, 'area', 'border', 'right', (ctx, dims, color) => {
      fillRect(ctx, dims, color, HALF_LENGTH, COURT.WIDTH - DOUBLES_MARGIN, HALF_LENGTH, DOUBLES_MARGIN);
    }),
    // Lines
    makePart('tennisDoublesSidelineTop', 200, 'line', 'lines', 'center', (ctx, dims, color) => {
      fillLineH(ctx, dims, color, 0, COURT.LENGTH, 0, COURT.LINE, 'inside-top');
    }),
    makePart('tennisDoublesSidelineBottom', 210, 'line', 'lines', 'center', (ctx, dims, color) => {
      fillLineH(ctx, dims, color, 0, COURT.LENGTH, COURT.WIDTH, COURT.LINE, 'inside-bottom');
    }),
    makePart('tennisSinglesSidelineTop', 220, 'line', 'lines', 'center', (ctx, dims, color) => {
      fillLineH(ctx, dims, color, 0, COURT.LENGTH, DOUBLES_MARGIN, COURT.LINE, 'inside-top');
    }),
    makePart('tennisSinglesSidelineBottom', 230, 'line', 'lines', 'center', (ctx, dims, color) => {
      fillLineH(ctx, dims, color, 0, COURT.LENGTH, COURT.WIDTH - DOUBLES_MARGIN, COURT.LINE, 'inside-bottom');
    }),
    makePart('tennisBaselineLeft', 240, 'line', 'lines', 'center', (ctx, dims, color) => {
      fillLineV(ctx, dims, color, 0, 0, COURT.WIDTH, COURT.LINE, 'inside-left');
    }),
    makePart('tennisBaselineRight', 250, 'line', 'lines', 'center', (ctx, dims, color) => {
      fillLineV(ctx, dims, color, COURT.LENGTH, 0, COURT.WIDTH, COURT.LINE, 'inside-right');
    }),
    makePart('tennisServiceLineLeft', 260, 'line', 'lines', 'center', (ctx, dims, color) => {
      fillLineV(ctx, dims, color, LEFT_SERVICE_START, DOUBLES_MARGIN, COURT.WIDTH - DOUBLES_MARGIN, COURT.LINE, 'inside-left');
    }),
    makePart('tennisServiceLineRight', 270, 'line', 'lines', 'center', (ctx, dims, color) => {
      const x = COURT.LENGTH - LEFT_SERVICE_START;
      fillLineV(ctx, dims, color, x, DOUBLES_MARGIN, COURT.WIDTH - DOUBLES_MARGIN, COURT.LINE, 'inside-right');
    }),
    makePart('tennisCenterServiceLine', 280, 'line', 'lines', 'center', (ctx, dims, color) => {
      fillLineH(ctx, dims, color, LEFT_SERVICE_START, COURT.LENGTH - LEFT_SERVICE_START, CENTER_Y, COURT.LINE, 'center');
    }),
    makePart('tennisNetLine', 290, 'line', 'lines', 'center', (ctx, dims, color) => {
      fillLineV(ctx, dims, color, HALF_LENGTH, 0, COURT.WIDTH, COURT.LINE, 'center');
    }),
    makePart('tennisCenterMarks', 300, 'line', 'lines', 'center', (ctx, dims, color) => {
      drawCenterMarks(ctx, dims, color);
    })
  ];

  const PART_LOOKUP = PARTS.reduce((acc, part) => {
    acc[part.id] = part;
    return acc;
  }, Object.create(null));
  const DRAW_ORDER = PARTS.slice().sort((a, b) => a.order - b.order).map(part => part.id);
  const LINE_ONLY_ORDER = DRAW_ORDER.filter(id => PART_LOOKUP[id] && PART_LOOKUP[id].role === 'line');

  function computeDims(cw, ch, opts) {
    const scaleX = cw / COURT.LENGTH;
    const scaleY = ch / COURT.WIDTH;
    return {
      scaleX,
      scaleY,
      scaleAvg: (scaleX + scaleY) * 0.5,
      fixedLineWidthPx: Math.max(0, Number(opts && opts.fixedLineWidthPx) || 0),
      cw,
      ch
    };
  }

  function pickDetailColor(detailColors, fallbackColors, id, fallback, baseColor) {
    if (detailColors && detailColors[id]) {
      if (detailColors[id] === SKIP_COLOR) return null;
      return detailColors[id];
    }
    if (fallbackColors && fallbackColors[id]) {
      if (fallbackColors[id] === SKIP_COLOR) return null;
      return fallbackColors[id];
    }
    if (fallback === 'key') return baseColor.key || baseColor.main;
    if (fallback === 'border') return baseColor.border || baseColor.main;
    if (fallback === 'lines') return baseColor.lines;
    return baseColor.main;
  }

  const DEFAULT_PALETTE = {
    main: '#218719',
    key: '#67C94E',
    border: '#125000',
    lines: '#FFFFFF'
  };

  function draw(ctx, x0, y0, cw, ch, color, opts) {
    if (!ctx || !cw || !ch) return;
    const detailColors = (opts && opts.detailColors) || null;
    const fallbackColors = (opts && opts.fallbackColors) || null;
    const only = (opts && (opts.only === 'left' || opts.only === 'right')) ? opts.only : null;
    const useDetailedParts = !!(opts && opts.useDetailedParts);
    const hasCustom = hasKeys(detailColors) || hasKeys(fallbackColors);
    const drawDetailed = useDetailedParts || hasCustom;
    const order = drawDetailed ? DRAW_ORDER : LINE_ONLY_ORDER;

    ctx.save();
    ctx.translate(x0, y0);
    const dims = computeDims(cw, ch, opts);
    dims.hardwood = opts && opts.hardwood;
    dims.pattern = opts && opts.pattern;
    dims.patternTargetPrefix = opts && opts.patternTargetPrefix;
    const palette = {
      main: DEFAULT_PALETTE.main,
      key: DEFAULT_PALETTE.key,
      border: DEFAULT_PALETTE.border,
      lines: normHex(color || DEFAULT_PALETTE.lines)
    };

    for (const id of order) {
      const part = PART_LOOKUP[id];
      if (!part) continue;
      if (only && part.side && part.side !== only && part.side !== 'center') continue;
      const fill = pickDetailColor(detailColors, fallbackColors, id, part.fallback, palette);
      if (!fill) continue;
      try {
        dims.patternTarget = { id: (dims.patternTargetPrefix || '') + id, role: part.role, fallback: part.fallback };
        part.draw(ctx, dims, normHex(fill));
      } catch (err) {
        console.warn('[SwishTennisLines] draw error for part', id, err);
      }
    }

    ctx.restore();
  }

  const api = {
    design: { W: COURT.WIDTH * 1000, L: COURT.LENGTH * 1000 },
    draw,
    ready: Promise.resolve()
  };

  return api;
}));
